import { constructUrl } from '@ynap/url-configuration';

export default function (urlConfig, route, locale) {
    if (!urlConfig || !locale) return '';

    const {
        wishlist: { construct: wishlistUrlTemplate },
    } = urlConfig || {};

    const url = constructUrl(wishlistUrlTemplate, {
        ROUTE: route ? route : '',
        LOCALE: locale,
    });

    window.location.assign(url);
}
